// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addfeature-body {
    padding: 1em;
}
.addfeature-hint {
    margin-bottom: .75em;
    color: #6b7070;
    font-size: .9em;
}
.addfeature-typelist {
    margin: 0;
    padding: 0;
    list-style: none;
}
.addfeature-typelist li {
    display: flex;
    align-items: center;
    gap: .75em;
    padding: .7em .8em;
    margin-bottom: .5em;
    background-color: #fff;
    border: 1px solid #d3d6d5;
    border-left: 4px solid #d3d6d5;
    border-radius: 2px;
    cursor: pointer;
    transition: border-color 0.15s, background-color 0.15s, box-shadow 0.15s;
}
.addfeature-typelist li:hover {
    background-color: #eef6f8;
    border-color: #078aa3;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.addfeature-typelist li > span.icon:first-child,
.addfeature-selected > span.icon {
    color: #078aa3;
    font-size: 1.2em;
}
.addfeature-typelist-label {
    flex: 1 1 auto;
}
.addfeature-typelist li > span.addfeature-typelist-arrow {
    color: #8a8f8e;
    font-size: .8em;
}
.addfeature-typelist li:hover > span.addfeature-typelist-arrow {
    color: #078aa3;
}
.addfeature-selected {
    display: flex;
    align-items: center;
    gap: .75em;
    padding: .7em .8em;
    margin-bottom: .75em;
    font-weight: bold;
    background-color: #eef6f8;
    border: 1px solid #078aa3;
    border-left-width: 4px;
    border-radius: 2px;
}
.addfeature-cancel {
    width: 100%;
    padding: .6em 1em;
}

/* Hide the AddFeature toolbar button (desktop) / menu entry (mobile) for users without the required role.
   qwc2's TaskButton/AppMenu render from static config and have no per-item visibility hook, so AddFeature.jsx
   toggles the "addfeature-allowed" class on <body> and this rule reacts to it, targeting the button/menu-item
   by the icon it renders (only used by this plugin). */
body:not(.addfeature-allowed) .map-button:has(.icon-addfeature),
body:not(.addfeature-allowed) .appmenu-leaf:has(.icon-addfeature) {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./js/style/AddFeature.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,cAAc;IACd,eAAe;AACnB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,wEAAwE;AAC5E;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,yCAAyC;AAC7C;AACA;;IAEI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;uDAGuD;AACvD;;IAEI,wBAAwB;AAC5B","sourcesContent":[".addfeature-body {\n    padding: 1em;\n}\n.addfeature-hint {\n    margin-bottom: .75em;\n    color: #6b7070;\n    font-size: .9em;\n}\n.addfeature-typelist {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n.addfeature-typelist li {\n    display: flex;\n    align-items: center;\n    gap: .75em;\n    padding: .7em .8em;\n    margin-bottom: .5em;\n    background-color: #fff;\n    border: 1px solid #d3d6d5;\n    border-left: 4px solid #d3d6d5;\n    border-radius: 2px;\n    cursor: pointer;\n    transition: border-color 0.15s, background-color 0.15s, box-shadow 0.15s;\n}\n.addfeature-typelist li:hover {\n    background-color: #eef6f8;\n    border-color: #078aa3;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n.addfeature-typelist li > span.icon:first-child,\n.addfeature-selected > span.icon {\n    color: #078aa3;\n    font-size: 1.2em;\n}\n.addfeature-typelist-label {\n    flex: 1 1 auto;\n}\n.addfeature-typelist li > span.addfeature-typelist-arrow {\n    color: #8a8f8e;\n    font-size: .8em;\n}\n.addfeature-typelist li:hover > span.addfeature-typelist-arrow {\n    color: #078aa3;\n}\n.addfeature-selected {\n    display: flex;\n    align-items: center;\n    gap: .75em;\n    padding: .7em .8em;\n    margin-bottom: .75em;\n    font-weight: bold;\n    background-color: #eef6f8;\n    border: 1px solid #078aa3;\n    border-left-width: 4px;\n    border-radius: 2px;\n}\n.addfeature-cancel {\n    width: 100%;\n    padding: .6em 1em;\n}\n\n/* Hide the AddFeature toolbar button (desktop) / menu entry (mobile) for users without the required role.\n   qwc2's TaskButton/AppMenu render from static config and have no per-item visibility hook, so AddFeature.jsx\n   toggles the \"addfeature-allowed\" class on <body> and this rule reacts to it, targeting the button/menu-item\n   by the icon it renders (only used by this plugin). */\nbody:not(.addfeature-allowed) .map-button:has(.icon-addfeature),\nbody:not(.addfeature-allowed) .appmenu-leaf:has(.icon-addfeature) {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
